// @flow
import * as React from 'react'
import styled, { css } from 'styled-components'
import Theme from 'ui/theme'

type Props = {
  children: any,
  onClick: () => void,
  isHighlighted?: boolean,
  width?: number,
}

const StyledButtonOutline = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  border-width: ${Theme.width.border};
  border-radius: ${Theme.borderRadius.small};
  border-color: ${Theme.color.borderSecondary};
  padding: ${Theme.spacing.xsmall};
  width: 50%;
  background: ${Theme.color.white};
  border-color: ${Theme.color.borderSecondary};

  ${({ isHighlighted }: Props) =>
    isHighlighted
      ? css`
          background: ${Theme.color.main};
          border-color: ${Theme.color.borderPrimary};
        `
      : css``}
`

const ButtonOutline = ({
  children,
  onClick,
  isHighlighted,
  width,
}: Props): React$Element<'div'> => {
  return (
    <StyledButtonOutline isHighlighted={isHighlighted} onClick={onClick}>
      {children}
    </StyledButtonOutline>
  )
}

export default ButtonOutline
